import { trackAmplitudeEvent } from '../tools/amplitude'
import config from '../tools/amplitude/config.json'
// interfaces
import { TrackButtonEvent } from '@/js/models/common'

const setTrackButtonEvent = ({ buttonName, buttonText, buttonFrom }: TrackButtonEvent): void => {
  trackAmplitudeEvent(config.events.clickButton, {
    button_name: buttonName,
    button_text: buttonText,
    from: buttonFrom
  })
}

export const setTrackDownloadCTAEvent = (): void => {
  const btns = document.querySelectorAll<HTMLElement>('.gtm-download-cta')
  if (btns) {
    btns.forEach((btn: HTMLElement): void => {
      const buttonText = btn.getAttribute('data-text')

      btn.addEventListener('click', (): void => {
        setTrackButtonEvent({ buttonName: 'download', buttonText, buttonFrom: 'worksheets_single' })
      })
    })
  }
}

export const setTrackDownloadPDFEvent = (): void => {
  const btns = document.querySelectorAll<HTMLElement>('.gtm-download-pdf-cta')
  if (btns) {
    btns.forEach((btn) => {
      const buttonText = btn.getAttribute('data-text')

      btn.addEventListener('click', () => {
        setTrackButtonEvent({ buttonName: 'download_pdf_file', buttonText, buttonFrom: 'download_popup' })
      })
    })
  }
}

export const setTrackWorksheetsImgEvent = (): void => {
  const btns = document.querySelectorAll<HTMLElement>('.gtm-worksheets-img')
  if (btns) {
    btns.forEach((btn) => {
      const buttonText = btn.getAttribute('data-text')

      btn.addEventListener('click', () => {
        setTrackButtonEvent({ buttonName: 'worksheets_img', buttonText, buttonFrom: 'worksheets_single' })
      })
    })
  }
}

export const setTrackExitPopupCloseEvent = (): void => {
  const btns = document.querySelectorAll<HTMLElement>('.gtm-exit-popup-close')
  if (btns) {
    btns.forEach((btn) => {
      const buttonText = btn.getAttribute('data-text')

      btn.addEventListener('click', () => {
        setTrackButtonEvent({ buttonName: 'close', buttonText, buttonFrom: 'exit_popup' })
      })
    })
  }
}

export const setTrackStripCloseEvent = (): void => {
  const btns = document.querySelectorAll<HTMLElement>('.gtm-strip-close-cta')
  if (btns) {
    btns.forEach((btn) => {
      const buttonText = btn.getAttribute('data-text')

      btn.addEventListener('click', () => {
        setTrackButtonEvent({ buttonName: 'close', buttonText, buttonFrom: 'sticky_form' })
      })
    })
  }
}
